import {displayGithubReferencesTool} from '../components/github-reference-tool'

/**
 * Tools added here need no host callbacks, so the Mission Control bootstrap
 * can contribute them when a caller creates the daemon session, without the
 * call site listing them. Non-contributing paths avoid claiming the active-client
 * role and displacing a host-bound surface; unavailable tools fail fast in the
 * host so the model can fall back to prose. Tools that require runtime callbacks
 * or adapters do not belong in this catalog.
 */
export const HOST_INDEPENDENT_CLIENT_TOOLS = [displayGithubReferencesTool] as const
